var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:!(_vm.isConverted || _vm.isExpired) ? 'text-primary cursor-pointer' : '',on:{"click":_vm.navigateToQuote}},[_vm._v(" "+_vm._s(_vm.row.quoteId)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }